export function TabText({
  children,
}: {
  children: string
}): React.ReactElement {
  return (
    <span className="grid justify-items-center">
      <span
        aria-hidden
        className="invisible col-start-1 row-start-1 text-small-medium"
      >
        {children}
      </span>
      <span className="col-start-1 row-start-1">{children}</span>
    </span>
  )
}
